export const toPascalCase = (str: string) => {
  const stripped = str.replaceAll('-', '');
  if (/^\d+$/.test(stripped)) return str;
  return (str.match(/[a-zA-Z0-9]+/g) || []).map(w => `${w.charAt(0).toUpperCase()}${w.slice(1)}`).join(' ')
}